<template>
  <p
    class="ocorrencia-item"
    style="font-weight: normal"
    @click="click"
  >
    <span class="title">
      {{ row.descricaoTipoServico }}
    </span>
    <span class="sub-item">
      Protocolo: {{ row.numeroProtocolo }}
    </span>
    <span class="sub-item">
      Beneficiário: {{ row.nomeBeneficiario }}
    </span>
  </p>
</template>
<script>
export default {
  name: 'OcorrenciaItem',
  props: ['column', 'row'],
  methods: {
    click () {
      if (this.column && this.column.click) {
        this.column.click(this.row)
      }
      this.$emit('click', this.row)
    }
  }
}
</script>
